import React from 'react';
import classNames from 'classnames';
import formatNumber from 'utils/formatNumber';
import decimalPlaces from 'utils/decimalPlaces';
import { trendClass } from 'utils/trend';

if (process.env.NODE_ENV !== 'test') {
  require('./InventoryQuote.scss');
}

export const InventoryTable = ({
  ticker,
  holding,
  last,
  lastnz_ca,
  change,
  changePct,
  formattedTime,
}) => {
  return (
    <div className="InventoryQuote">
      <div>
        <div className="item">
          <div>
            <b>Ticker</b>
          </div>
          <p className="big-blue">{ticker}</p>
        </div>
      </div>
      <table className="quote">
        <thead>
          <tr>
            <th title="Disponibel Beholdning">Disp.Beh.</th>
            <th>Siste</th>
            <th>+/-</th>
            <th>+/-%</th>
            <th>Oppdatert</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td data-header="Disp.Beh." className="big-blue">
              <span>{holding}</span>
            </td>
            <td data-header="Siste" className="big-blue">
              <span>
                {formatNumber(
                  last || lastnz_ca,
                  decimalPlaces(last || lastnz_ca),
                )}
              </span>
            </td>
            <td data-header="+/-" className="big-blue">
              <span className={classNames(trendClass(change))}>
                {formatNumber(change, 3)}
              </span>
            </td>
            <td data-header="+/-%" className="big-blue">
              <span className={classNames(trendClass(changePct))}>
                {formatNumber(changePct)}%
              </span>
            </td>
            <td data-header="Oppdatert" className="big-blue">
              <span>{formattedTime}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
